/**
 * Returns the base URL for images.
 * - If REACT_APP_IMAGES_BASE_URL is set, uses that (e.g. CDN URL)
 * - Otherwise falls back to PUBLIC_URL/images
 */
const IMAGES_BASE = process.env.REACT_APP_IMAGES_BASE_URL || `${process.env.PUBLIC_URL}/images`;

export const getImageUrl = (path) => `${IMAGES_BASE}/${path}`;
